// 受取者
export class ReceptionRecipient {
  public receiptDate: Date;
  public receiptTime: Date;
  public name: string;
  public relationship: string;
  public paymentStatus: number;
  public receiptMoney: string;
  public note: string;

  clone(): ReceptionRecipient {
    const newObj = new ReceptionRecipient();
    newObj.receiptDate = this.receiptDate;
    newObj.receiptTime = this.receiptTime;
    newObj.name = this.name;
    newObj.relationship = this.relationship;
    newObj.paymentStatus = this.paymentStatus;
    newObj.receiptMoney = this.receiptMoney;
    newObj.note = this.note;

    return newObj;
  }
}
